<div class="background">
    <div class="card-container">
        <mat-card class="order-manager-card">

            <div class="card-heading-container" *ngIf="
                            router.url.includes('/order-manager/my-order') || 
                            router.url.includes('/order-manager/approvals') || 
                            router.url.includes('/order-manager/approved-orders')">

                <img src="../../../../../assets/order-to-cash-icons/content-paste-search.svg" alt="Order Manager Icon"
                     class="om-header-icon">
                <p class="om-header-text">Order Manager</p></div>


            <div class="order-manager-toggle-btn-container" *ngIf="
                            router.url.includes('/order-manager/my-order') || 
                            router.url.includes('/order-manager/approvals') || 
                            router.url.includes('/order-manager/approved-orders')">
                <div class="order-manager-btn-container">
                    <a class="my-orders-btn" mat-flat-button type="button" routerLink="/order-manager/my-orders" routerLinkActive="active-my-orders-btn">My Orders</a>
                </div>

                <div class="order-manager-btn-container"  *ngIf="isApprovalsVisable">
                    <a class="approval-btn" mat-flat-button type="button" routerLink="/order-manager/approvals" routerLinkActive="active-approval-btn" [routerLinkActiveOptions]="{exact: true}">Approvals</a>
                </div>

                <div class="order-manager-btn-container"  *ngIf="isApprovalsVisable">
                    <a class="approved-btn" mat-flat-button type="button" routerLink="/order-manager/approved-orders" routerLinkActive="active-approved-btn" [routerLinkActiveOptions]="{exact: true}">Order History</a>
                </div>
            </div>
            <router-outlet></router-outlet>
        </mat-card>

    </div>
</div>




